import classnames from "classnames";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Drag } from "neetoicons";
import { Tooltip, Typography } from "neetoui";

const Element = ({
  label,
  icon: Icon,
  isCreatable = true,
  onClick,
  isDragDisabled = false,
  disabledElementTooltip,
  isPlaceholder,
  isDraggingOver,
  isAddingNewElement,
}) => {
  const handleClick = event => {
    if (!isCreatable || isAddingNewElement) {
      event.preventDefault();

      return;
    }

    onClick(event);
  };

  return (
    <Tooltip
      content={disabledElementTooltip?.(label)}
      disabled={!disabledElementTooltip || isCreatable || isDraggingOver}
      position="top"
      touch={["hold", 500]}
    >
      <div
        data-testid={`add-${joinHyphenCase(label)}-element`}
        className={classnames(
          "neeto-ui-border-gray-400 neeto-ui-bg-white hover:neeto-ui-bg-gray-200 neeto-ui-rounded-lg relative mb-2 flex h-10 items-center gap-2 border p-3 transition-all duration-300 ease-in-out",
          {
            "neeto-ui-bg-gray-300 cursor-not-allowed": !isCreatable,
            "cursor-pointer": isCreatable,
            "opacity-50": isPlaceholder,
          }
        )}
        onClick={handleClick}
      >
        {!isDragDisabled && (
          <span
            className="absolute end-full top-1/2 me-0.5 flex-shrink-0 -translate-y-1/2 cursor-grab"
            data-testid="drag-handle"
          >
            <Drag
              className="neeto-ui-text-gray-400 hover:neeto-ui-text-gray-500 transition-all duration-300 ease-in-out"
              size={16}
            />
          </span>
        )}
        <div className="flex flex-grow items-center gap-2">
          {Icon && <Icon data-testid="form-icon" />}
          <Typography className="leading-4" style="body2">
            {label}
          </Typography>
        </div>
      </div>
    </Tooltip>
  );
};

export default Element;
